// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_a5b65c', '__aime_Fallback_a5b65c'"},"className":"__className_a5b65c","variable":"__variable_a5b65c"};